export default function stopEvent(e) {
    if ('stopImmediatePropagation' in e) e.stopImmediatePropagation();
    if ('preventDefault' in e) e.preventDefault();
    if ('stopPropagation' in e) e.stopPropagation();
    return false;
}